export default __webpack_public_path__ + "static/media/GAN6.a9ee5802.png";